<div class="content">
  <div class="logo">
    <app-logo [size]="60"></app-logo>
    <app-site-name></app-site-name>
  </div>
  <div class="links">
    <h5>Customer Care</h5>
    <ul>
      @if (profile) {
      <li>
        <a routerLink="/account" aria-label="Account Page">Account</a>
      </li>
      <li><a routerLink="/account/orders" aria-label="Orders Page">Orders</a></li>
      }@else{
      <li>
        <a routerLink="/login" aria-label="Login">Account</a>
      </li>
      <li><a routerLink="/login" aria-label="Login">Orders</a></li>
      }
      <li><a (click)="toggleShoppingBag()" aria-label="Open Shopping Bag">Shopping Bag</a></li>
      <!-- <li>
        <a routerLink="/faq">FAQ</a>
      </li> -->
    </ul>
  </div>
  <div class="links">
    <h5>Legal</h5>
    <ul>
      <li>
        <a routerLink="/privacy-policy" aria-label="Privacy Policy">Privacy Policy</a>
      </li>
      <li>
        <a routerLink="/terms-of-service">Terms of Service</a>
      </li>
      <li>
        <a routerLink="/return-and-exchange-policy">Return & Exchange Policy</a>
      </li>
    </ul>
  </div>
  <div class="links">
    <h5>About</h5>
    <ul>
      <li>
        <a routerLink="/about-us">About Us</a>
      </li>
      <li><a routerLink="/contact-us">Contact Us</a></li>
    </ul>
  </div>
  <div class="links">
    <a href="https://transparencyreport.google.com/safe-browsing/search?url=https:%2F%2Flaceliora.com&hl=en"
      target="_blank" rel="noopener noreferrer" aria-label="Google Safe Browsing">
      <img src="images/icons/safebrowsing.png" width="150px" alt="Google Safe Browsing" />
    </a>
    <a style="margin-top: 10px" href="https://stripe.com" target="_blank" rel="noopener noreferrer"
      aria-label="Stripe Website">
      <img src="images/icons/powered_by_stripe.svg" width="150px" alt="Powered by Stripe" />
    </a>
  </div>
</div>

<!-- <div class="platforms">
  <app-fashion-go-button></app-fashion-go-button>
  <app-boutiquehub-button></app-boutiquehub-button>
</div> -->
<p>©2024-2026 {{appname}}. All rights reserved.</p>